import { render } from "./Geo.vue?vue&type=template&id=9b3031be&ts=true"
import script from "./Geo.vue?vue&type=script&lang=ts"
export * from "./Geo.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__